module.exports = __webpack_public_path__ + "assets/img/IMG013.eda6e3f7.png";